import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { isPermitted } from "util/PermissionsMixin";
import { Alert } from "components/bootstrap";
import useCurrentUser from "hooks/useCurrentUser";
import { useParameterType } from "./ParameterTypes";
const PermissionsAlert = styled(Alert)`
  margin-top: 10px;
`;
const useValidatePermissions = (idx, editPermissions, title, onValidate) => {
  const currentUser = useCurrentUser();
  const hasEditPermissions = isPermitted(currentUser == null ? void 0 : currentUser.permissions, editPermissions);
  useEffect(() => {
    const _validationState = hasEditPermissions ? ["success"] : ["error", ""];
    onValidate(idx, { typeEditPermissions: _validationState });
    return () => onValidate(idx, { typeEditPermissions: ["success"] });
  }, [idx, editPermissions, title, hasEditPermissions, onValidate]);
  return hasEditPermissions;
};
const TypeSpecificDeclarationFields = ({ idx, type, parameter, onChange, validationState, onValidate }) => {
  const { editComponent: Component, editPermissions, title } = useParameterType(type);
  const hasEditPermissions = useValidatePermissions(idx, editPermissions, title, onValidate);
  if (!hasEditPermissions) {
    return /* @__PURE__ */ React.createElement(PermissionsAlert, { bsStyle: "danger" }, 'You currently do not have the permissions to create or edit a "', title, '" parameter. Required permissions: ', editPermissions == null ? void 0 : editPermissions.join(","));
  }
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      idx,
      parameter,
      onChange,
      validationState,
      onValidate
    }
  );
};
export default TypeSpecificDeclarationFields;
